// extracted by mini-css-extract-plugin
export default {"onlineTraining__buttonGroup":"OnlineTraining_onlineTraining__buttonGroup__7Pser","onlineTraining__dataButton":"OnlineTraining_onlineTraining__dataButton__dggcH"};